import { render } from "./RetailerOrders.vue?vue&type=template&id=bde6b13e&scoped=true"
import script from "./RetailerOrders.vue?vue&type=script&lang=js"
export * from "./RetailerOrders.vue?vue&type=script&lang=js"

import "./RetailerOrders.vue?vue&type=style&index=0&id=bde6b13e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bde6b13e"]])

export default __exports__